<template>
    <div class="card">
        <div class="img-card">
            <img :src="image" alt="Card image" />
        </div>
        <h2 class="card-title">{{ title }}</h2>
        <p class="card-content" v-html="content"></p>

        <div style="margin-top: -20px; display: flex; justify-content: start; align-items: center; width: 100%;">
            <CalendarDays style="size: 10px; color: #6D6D6D;" />
            <p style="font-size: 12px; color: #6D6D6D; font-weight: 400; margin: 0%; padding: 0%;">{{new Date(date).toDateString() }}</p>
        </div>
    </div>
</template>

<script setup>
import { CalendarDays } from "lucide-vue-next";

/* eslint-disable */
defineProps({
    types: {
        type: String,
        required: true
    },
    title: {
        type: String,
        required: true
    },
    content: {
        type: String,
        default: ""
    },
    image: {
        type: String,
        default: null
    },
    date: {
        type: String,
        default: null
    },
});
</script>

<style lang="scss" scoped>
.card {
    border-radius: 24px;
    padding: 16px;
    height: 340px;
    width: 100%;
    border: 1px solid #DCE3E7;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: transparent;
}
.img-card{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;

    img{
        width: 100%;
        height: 180px;
    }
}

.img-title{
    background-color: #ED4E24; 
    color: white; 
    padding: 5px 10px; 
    border-radius: 8px; 
    position: absolute; 
    top: 10px; 
    left: 20px; 
    font-size: 10px;
}
.card-title {
    font-size: 17px;
    color: #000000;
    font-weight: 700;
    margin: 10px 0;
    text-align: left;
    font-family: "Open Runde", sans-serif;
}

.card-content {
    font-size: 13px !important;
    color: #454545;
    font-weight: 400;
    text-align: left;
    font-family: "Open Runde", sans-serif;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }

    .img-card{
        img{
            width: 100%;
        }
    }
}
</style>
